<app-header></app-header>
<div class="container-fluid">
  <h2>FAANG Publications</h2>
  <hr>
    @if (hasActiveFilters()) {
      <h3 fxLayout="row" fxLayoutGap="2%">
        <div fxFlex="20"></div>
        <div fxFlex="80">
          @defer (when hasActiveFilters()) {
            <app-active-filter></app-active-filter>
          }
          @loading {
            Loading active filters...
          } @error {
            Failed to load active filters!
          }
          <button mat-raised-button (click)="removeFilter()">Remove all filters</button>
          <hr>
          </div>
        </h3>
      }

      <div fxLayoutGap="2%" fxLayout="row" fxLayout.lt-md="column">
        <div fxFlex="17">
          <app-filter title="Dataset source" [filterSize]=2></app-filter>
          <app-filter title="Year" [filterSize]=6></app-filter>
          <app-filter title="Journal" [filterSize]=6></app-filter>
          <app-filter title="Project" [filterSize]=4></app-filter>
          <app-filter title="Article Type" [filterSize]=2></app-filter>
        </div>

        <div fxFlex="83" class="table-responsive">
          <button mat-raised-button style="background-color: green; color: white;" (click)="onDownloadData()" [disabled]="downloading">
            Download data
          </button>
          @if (downloadData) {
            <button (click)="downloadFile('csv')" mat-raised-button>
              Export as CSV file
            </button>
          }
          @if (downloadData) {
            <button (click)="downloadFile('txt')" mat-raised-button>
              Export as Tabular file
            </button>
          }

          @if (downloading) {
            <div style="padding: 15px">
              <mat-spinner [diameter]="30"></mat-spinner>
            </div>
          }

          <app-table-server-side  [display_fields]="displayFields"
            [column_names]="columnNames"
            [indexDetails]="indexDetails"
            [templates]="templates"
            [filter_values]="filter_field"
            [apiFunction]="loadTableDataFunction"
            [query]="query"
            [defaultSort]="defaultSort">
          </app-table-server-side>
        </div>
      </div>
    </div>

    <ng-template #titleTemplate let-item>
      <a style="cursor: pointer" target="_blank" [routerLink]="item['id']">{{item['title']}}</a>
    </ng-template>

    <ng-template #articleSourceTemplate let-item>
      <span [ngClass]="isPublished(item['source'])"> {{isPublished(item['source'])}} </span>
    </ng-template>
